import { BaseInfo } from '@/models/baseInfo';
import { TimeMinutesSecondsFormat } from '@/models/common';
import * as wecom from '@wecom/jssdk';
import dayjs from 'dayjs';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { Action, APIState, createAPIActionTypes, createAPIReducer } from '.';
import { api } from '../../../api';

export type BaseInfoState = APIState<BaseInfo>;

export const BaseInfoActionTypes = createAPIActionTypes('base');
export const baseInfoReducer = createAPIReducer<BaseInfoState>(BaseInfoActionTypes);

export function* fetch({ payload: params }: Action) {
  try {
    const payload = yield call(api.get, {
      url: `/baseInfo`,
      params,
      withCredentials: true,
      retry: 5,
    });

    payload.isWeCom = wecom.env.isWeCom;
    if (payload.isWeCom) {
      // 企微注册应用信息
      wecom.register({
        corpId: 'ww6877ee8050c41c49',
        agentId: 1000002,
        jsApiList: [
          'getCurExternalContact',
          'selectExternalContact',
          'getContext',
          'sendChatMessage',
          'openEnterpriseChat',
        ],
        getConfigSignature: async url => {
          // 根据 url 生成 config 签名信息
          const result = await api.post<{ timestamp: string; nonceStr: string; signature: string }>({
            url: `/auth/wecom/jsapi/signature`,
            data: { url },
          });
          return result;
        },
        getAgentConfigSignature: async url => {
          // 根据 url 生成 config 签名信息
          const result = await api.post<{ timestamp: string; nonceStr: string; signature: string }>({
            url: `/auth/wecom/jsapi/agent/signature`,
            data: { url },
          });
          return result;
        },
      });

      try {
        const externalContactUserInfo = yield call(wecom.getCurExternalContact);
        payload.externalContactWecomId = externalContactUserInfo.userId;
      } catch (e) {}
    }

    if (payload.perms) {
      payload.perms = new Set(payload.perms);
    }

    try {
      // 时间相关字段格式化
      if (payload.poiConfig) {
        if (payload.poiConfig.earliestBookingTime) {
          payload.poiConfig.earliestBookingTime = dayjs(
            payload.poiConfig.earliestBookingTime,
            TimeMinutesSecondsFormat
          );
        }
        if (payload.poiConfig.latestBookingTime) {
          payload.poiConfig.latestBookingTime = dayjs(payload.poiConfig.latestBookingTime, TimeMinutesSecondsFormat);
        }
      }
    } catch (e) {}

    // payload.assetsPrefix = 'https://cdn.il-canto.com/';

    yield put({
      type: BaseInfoActionTypes.success,
      payload,
    });
  } catch (e) {
    yield put({
      type: BaseInfoActionTypes.fail,
      payload: e,
    });
  }
}

export function* sagas() {
  yield all([takeLatest(BaseInfoActionTypes.fetch, fetch)]);
}
